import { ITaskRawQuery } from '@models/Task.model';

import { Icon as BlueIcon } from '@blueprintjs/core';

import { TaskDate } from '../TaskDate/TaskDate';
import { TaskMenu } from '../TaskMenu/TaskMenu';
import { TaskPriorityFlag } from '../TaskPriorityFlag/TaskPriorityFlag';

import { TaskStatusLabel } from '../TaskStatusLabel/TaskStatusLabel';
import { Container, Cell, Text, Empty, Iconleft } from './TaskRow.styles';
// import { TaskCategoryLabel } from '../TaskCategoryLabel/TaskCategoryLabel';
import { TaskAssigneeLabel } from '../TaskAssigneeLabel/TaskAssigneeLabel';

interface ITaskRow {
  task: ITaskRawQuery;
  openTask: () => void;
}

const TaskRow = ({ task, openTask }: ITaskRow) => {
  return (
    <Container onClick={openTask}>
      <Cell>
        {task.priority && ['important', 'urgent'].includes(task.priority) && (
          <Iconleft>
            <BlueIcon icon="double-chevron-up" color="#FF9900" />
          </Iconleft>
        )}
        {task.title ? <Text>{task.title}</Text> : <Empty>Empty</Empty>}
      </Cell>
      {/* <Cell>
        <TaskCategoryLabel task={task} />
      </Cell> */}
      <Cell>
        <TaskAssigneeLabel task={task} />
      </Cell>
      <Cell>
        <TaskPriorityFlag task={task} withText />
      </Cell>
      <Cell>
        <TaskDate task={task} />
      </Cell>
      <Cell>
        <TaskStatusLabel task={task} />
      </Cell>
      <Cell>
        <TaskMenu task={task} />
      </Cell>
    </Container>
  );
};

export { TaskRow };
